import React, { useEffect, useState, useContext } from 'react'
import styled from 'styled-components'
import { mq, px2rem, hiDPIpx, formatArtistLink, formatArtworkTitle } from '@utils'
import { getArtistsArray } from '@utils/catalog'
import ShowsInfoArtwork from '@components/GalleryProfile/Shared/ShowsInfoArtwork'
import { CustomLinkTag, ActionsBar } from '@components'
import { ButtonIcon } from '@mch-group/uikit-components'
import { useCollectionsContext } from '@modules/collections/contexts/useCollectionsContext'
import { AddToCollectionContext } from '@components/collections/AddToCollection'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'
import tokensRenamed from '@constants/tokensRenamed'
import IArtworkCard from 'types/IArtworkCard'

const ArtworkTitle: React.FC<IArtworkCard> = ({
  artistId,
  artistCleanTitle,
  artistName,
  id,
  year,
  endYear,
  displayName,
  showPlacement,
  sponsorArtists
}) => {
  const { showAddToCollectionModal } = useContext(AddToCollectionContext)
  //@ts-ignore
  const [{ labels }] = useCollectionsContext()
  const [artists, setArtists] = useState<Array<{ artistId: number; artistCleanTitle: string; artistName: string }>>([])

  useEffect(() => {
    setArtists(getArtistsArray(artistId, artistCleanTitle, artistName, sponsorArtists))
  }, [artistId, artistCleanTitle, artistName, sponsorArtists])

  return (
    <TitleWrapper>
      <Heading>
        <div>
          <h3>
            {formatArtworkTitle(displayName, year, endYear)}
          </h3>
          <ArtistName>
            {artists.map((item, index) => (
              <React.Fragment key={item.artistId}>
                <CustomLinkTag
                  url={formatArtistLink(item.artistId, item.artistCleanTitle)}
                  extraParams={{ id: item.artistId.toString(), cleanTitle: item.artistCleanTitle }}
                >
                  <span>{item.artistName}</span>
                </CustomLinkTag>
                {index < artists.length - 1 ? ', ' : ''}
              </React.Fragment>
            ))}
          </ArtistName>
          <InfoBar>
            {/** @ts-ignore */}
            <ShowsInfoArtwork showPlacement={showPlacement} />
          </InfoBar>
        </div>
        <ActionsBar
          className='actions-bar'
          controls={[
            {
              key: 'Share'
            },
            {
              key: 'Add to Collection',
              icon: () => (
                <ButtonIcon
                  size='lg'
                  variant='outline'
                  icon='collections-add'
                  //@ts-ignore
                  onClick={() => showAddToCollectionModal(id, 2)}
                  title={labels?.AltTags?.addToCollection}
                />
              ),
              type: 'link'
            }
          ]}
        />
      </Heading>
    </TitleWrapper>
  )
}

const TitleWrapper = styled.section`
  &.ui.container {
    display: block;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${px2rem(36)};
    ${mq.lessThan('largestTablet')`
      margin-bottom: ${px2rem(40)};
    `}
  }
`

const Heading = styled.div`
  display: flex;
  ${mq.lessThan('largestTablet')`
    display: block;
  `}
  align-items: center;
  margin-bottom: ${px2rem(14)};

  & .ui.header.main-header {
    margin: 0;
    line-height: ${tokensRenamed.lineHeights[12].value};
    font-size: ${tokens.fontSize[7].value};
    ${mq.between('tablet', 'largestTablet')`
      line-height: ${hiDPIpx(32)};
      font-size: ${hiDPIpx(28)};
    `}

    ${mq.lessThan('largestMobile')`
      line-height: ${tokensRenamed.lineHeights[9].value};
      font-size: ${tokens.fontSize[6].value};
    `}
  }

  .favorite-button {
    margin-left: ${px2rem(26)};

    svg {
      display: block;
      margin-top: ${px2rem(8)};
    }
  }

  .actions-bar {
    ${mq.greaterThan('desktop')`
      margin-left: auto;
      align-self: baseline;
    `}
  }
`

const ArtistName = styled.div`
  font-size: ${tokens.fontSize[4].value};
`

const InfoBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${px2rem(32)} 0;
  margin-bottom: ${px2rem(32)};
  ${mq.between('tablet', 'largestTablet')`
    margin-bottom: ${hiDPIpx(57)};
  `}
  ${mq.lessThan('largestMobile')`
    margin-bottom: 0;
  `}
  ${mq.lessThan('largestTablet')`
    align-items: flex-start;
    flex-direction: column;
  `}
`

export default ArtworkTitle
